import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import InlineLoader from "@Shared/components/general/inline-loader.vue";
import MortgageSelector from "@Broker/@Modules/clients/applications/application/components/pages-components/direct-to-lender/mortgage-selector.vue";
import CommissionRecordContainer from "./comission-record/commission-record-container.vue";
import FeesContainer from "./fees/fees-container.vue";
import CommissionDeductionsContainer from "./commission-deductions/commission-deductions-container.vue";
import CommissionDetailsContainer from "./commission-details/commission-details-container.vue";
import NotesContainer from "./notes/notes-container.vue";
import { PRINT_COMMISSIONS } from "@Broker/@Modules/clients/applications/application/store/lender-submit-actions";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { APPLICATION_STATUS, CURRENT_APPLICATION_HAS_REQUESTED_MORTGAGES, NOT_REQUESTED_MORTGAGES, REQUESTED_MORTGAGES } from "../../../../store/application-getters";
import { mapActions, mapMutations, mapState, mapGetters } from "vuex";
import { SET_COMMISSIONS_FEE_MORTGAGE_TYPE } from "../../../../store/lender-submit-mutations";
import { CURRENT_COMMISSIONS_FEES_TOTAL } from "../../../../store/lender-submit-getters";
import { CURRENT_ACCOUNT_ACCESS_RIGHTS } from "@Broker/@Modules/main/store/account/account-getters";
import { LOAD_PERSONAL_DETAILS } from "@Broker/@Modules/main/store/account/account-actions";
import { defineComponent } from "@vue/composition-api";
import { showToast } from "@Shared/@Utils/constants";
export default defineComponent({
  name: "CommissionsContainer",
  components: {
    CommissionRecordContainer,
    FeesContainer,
    CommissionDeductionsContainer,
    CommissionDetailsContainer,
    NotesContainer,
    MortgageSelector,
    SimpleButton,
    InlineLoader
  },
  props: {
    applicationId: {
      type: Number,
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    },
    agentUsername: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loadingPrint: false,
      loadingPrintSucceeded: true,
      loadingDetails: true
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapState("ApplicationStore", ["commissions", "loadingTotalCommissionFees"])), mapGetters("ApplicationStore", [CURRENT_APPLICATION_HAS_REQUESTED_MORTGAGES, NOT_REQUESTED_MORTGAGES, CURRENT_COMMISSIONS_FEES_TOTAL, REQUESTED_MORTGAGES, APPLICATION_STATUS])), mapGetters("AccountStore", [CURRENT_ACCOUNT_ACCESS_RIGHTS])), {}, {
    disabledMortgages() {
      return this.NOT_REQUESTED_MORTGAGES;
    },
    currentCommissionsMortgageType() {
      return this.commissions.currentCommissionsMortgageType;
    },
    totalFeesAmount() {
      return this.CURRENT_COMMISSIONS_FEES_TOTAL;
    },
    canEditCommissions() {
      var _this$CURRENT_ACCOUNT;
      return (_this$CURRENT_ACCOUNT = this.CURRENT_ACCOUNT_ACCESS_RIGHTS) == null ? void 0 : _this$CURRENT_ACCOUNT.editCommissions;
    },
    isReadOnly() {
      var _this$CURRENT_ACCOUNT2;
      return !((_this$CURRENT_ACCOUNT2 = this.CURRENT_ACCOUNT_ACCESS_RIGHTS) != null && _this$CURRENT_ACCOUNT2.editCommissions) || this.APPLICATION_STATUS == "completed" || this.APPLICATION_STATUS == "paid";
    }
  }),
  watch: {
    canEditCommissions: {
      handler(value) {
        if (!value) {
          showToast("error", "userViewOnly");
        }
      },
      immediate: true
    }
  },
  beforeMount() {
    this.SET_COMMISSIONS_FEE_MORTGAGE_TYPE(this.REQUESTED_MORTGAGES[0]);
  },
  async mounted() {
    await this.LOAD_PERSONAL_DETAILS();
  },
  methods: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapActions("ApplicationStore", [PRINT_COMMISSIONS])), mapActions("AccountStore", [LOAD_PERSONAL_DETAILS])), mapMutations("ApplicationStore", [SET_COMMISSIONS_FEE_MORTGAGE_TYPE])), {}, {
    goToMortgageDetails() {
      this.$emit("page-change", "mortgage-details");
    },
    async printCommissions() {
      this.loadingPrint = true;
      const {
        succeeded
      } = await this.PRINT_COMMISSIONS({
        applicationId: this.applicationId,
        clientUsername: this.clientUsername,
        mortgage: this.currentCommissionsMortgageType
      });
      this.loadingPrintSucceeded = succeeded;
      this.loadingPrint = false;
    },
    handleChangeMortgageType(mortgageType) {
      this.SET_COMMISSIONS_FEE_MORTGAGE_TYPE(mortgageType);
    }
  })
});